import axios from 'axios';

const API_URL = '/';

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const login = async (username: string, password: string) => {
  const response = await api.post('api/token/', { username, password });
  return response.data;
};

export const getContacts = async () => {
  const response = await api.get('api/contacts/');
  return response.data;
};

export const startCall = async (contactId: number) => {
  const response = await api.post('api/calls/start_call/', { contact_id: contactId });
  return response.data;
};

export const getCalls = async () => {
  const response = await api.get('api/call-log/');
  console.log('Call Logs',response.data);
  return response.data;
};

export const createContact = async (name: string, phoneNumber: string, companyName: string) => {
  const response = await api.post('api/contacts/', {
    name,
    phone_number: phoneNumber,
    company_name: companyName,
  });
  return response.data;
};

export const callLog = async (data: any) => {
  const response = await api.post('api/call-log/',
    {
      data
    }
  );
  return response.data;
};
